import React, { useState } from "react";
import styles from "./confirm-window.module.scss";
import BlessButton from "@/components/layout/button/green-outline-btn";
import type { ModalProps } from "antd";
import useModPermsContracts from "@/features/mod-perms/hooks/useModPermsContracts.hook";
import LoadingIcon from "@/components/layout/loading-icon";
import { useAccount } from "wagmi";

interface Props extends Pick<ModalProps, "onCancel"> {
  onConfirm: () => any;
  header: string;
  paragraph: string;
}

const ConfirmWindow = ({ onCancel, header, onConfirm, paragraph }: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  async function handleConfirm() {
    setIsLoading(true);
    await onConfirm();
    setIsLoading(false);
  }

  return (
    <div className={styles.container}>
      <p className={styles.warning}>{header}</p>
      <p className={styles.header}>{paragraph}</p>
      <div className={styles.buttons}>
        <BlessButton
          buttonType="outlined"
          onClick={onCancel}
          styles={{ flex: 1 }}
        >
          Go back
        </BlessButton>
        <BlessButton
          color="lavender"
          onClick={handleConfirm}
          styles={{ gap: 5, flex: 1 }}
        >
          Confirm {isLoading && <LoadingIcon size={25} />}
        </BlessButton>
      </div>
    </div>
  );
};

export default ConfirmWindow;
